import { buildAnalyticsUrl } from '../../api/utils/apiUtils';

export default id => buildAnalyticsUrl(`${id}`);
